import { initialState } from './state'
import { PayloadAction } from '@reduxjs/toolkit'
import { TransactionSliceState } from 'src/core/models'

export const reducers = {
  /* Finalize Paypal Payment List Reducers */
  setFinalizePaypalPaymentLoading: (state: TransactionSliceState, action: PayloadAction<boolean>) => {
    state.finalizePaypalPayment.loading = action.payload
  },
  setFinalizePaypalPaymentSuccess: (state: TransactionSliceState, action: PayloadAction<boolean>) => {
    state.finalizePaypalPayment.success = action.payload
  },
  setFinalizePaypalPaymentError: (state: TransactionSliceState, action: PayloadAction<any>) => {
    state.finalizePaypalPayment.error = action.payload
  },
  resetFinalizePaypalPaymentState: (state: TransactionSliceState) => {
    state.finalizePaypalPayment = initialState.finalizePaypalPayment
  }
}
